import { useLocation, useNavigate } from 'react-router-dom';

import CompletedTransactionDetailScreen from 'components/Common/Transaction/CompletedTransactionDetailScreen';
import Routes from 'constants/routes';

const SendMoneyTransactionDetail = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { sendMoneyForm, filterTrxData, showFeeSection } = location.state || {};

    const backButtonNavigation = () => {
        if (sendMoneyForm) {
            navigate(Routes.sendAndRequest.main);
        } else {
            navigate(-1);
        }
    };

    return (
        <CompletedTransactionDetailScreen
            showFeeSection={showFeeSection}
            details={filterTrxData}
            backButtonNavigation={backButtonNavigation}
        />
    );
};
export default SendMoneyTransactionDetail;
